import { inject, Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import { ID_FIELD_OPTIONS, WW_NOTES_COLLECTION } from '@damofire/data-commons';
import { collection, collectionData, Firestore, orderBy, query, QueryConstraint, where } from '@angular/fire/firestore';
import { ObservableNoteService } from './note-observable.service';
import { Note } from './note.dto';
import { AuthenticationService, User } from '@damofire/data-security';

@Injectable()
export class FirebaseObservableNoteService extends ObservableNoteService {
  private readonly firestore = inject(Firestore);

  constructor(protected readonly appAuthService: AuthenticationService) {
    super();
  }

  observeIssueNotes(divisionId: string, issueId: string): Observable<Note[]> {
    return this.observeUserNotes(where('issue._id', '==', issueId));
  }

  observeNotes(divisionId: string, inspectionId: string, assetId?: string): Observable<Note[]> {
    const constraints = [where('division._id', '==', divisionId), where('inspection._id', '==', inspectionId)];
    if (assetId) {
      constraints.push(where('asset._id', '==', assetId));
    }
    return this.observeUserNotes(...constraints);
  }

  observeDivisionNotes(divisionId: string): Observable<Note[]> {
    return this.observeUserNotes(where('division._id', '==', divisionId));
  }

  private observeUserNotes(...queryConstraints: QueryConstraint[]): Observable<Note[]> {
    return new Observable<Note[]>((observer: Subscriber<Note[]>) => {
      this.appAuthService.currentUser().then((user: User) => {
        const queryFn = query(
          collection(this.firestore, WW_NOTES_COLLECTION),
          where('audit.createdBy', '==', user._id),
          ...queryConstraints,
          orderBy('audit.lastModifiedDate', 'desc'),
        );
        const sub = collectionData<Note>(queryFn, ID_FIELD_OPTIONS).subscribe((changes) => observer.next(changes));
        observer.add(sub);
      });
    });
  }
}
